import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AuthService } from '../../services/auth.service';
import { passwordMeetsRules, PasswordRulesComponent } from './password-rules.component';

@Component({
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule, PasswordModule, PasswordRulesComponent],
  templateUrl: './change-password.component.html',
  styleUrls: ['./auth-shell.scss'],
})
export class ChangePasswordComponent {
  passwordMeetsRules = passwordMeetsRules;
  error = '';
  success = '';
  working = false;
  oldpassword = '';
  newpassword = '';
  conpassword = '';

  constructor(private authService: AuthService, private router: Router) { }

  async onSubmit() {
    this.error = '';
    if (this.conpassword != this.newpassword) {
      this.error = "Passwords do not match";
      return;
    }
    if (this.working || this.success || !passwordMeetsRules(this.newpassword)) { return; }

    this.working = true;
    try {
      await this.authService.changePassword(this.oldpassword, this.newpassword);
      this.error = '';
      this.success = 'Password has been changed';
      this.working = false;
      setTimeout(() => this.authService.logout(), 3000);

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else if (err.status === 401) {
        this.error = err.error || 'Incorrect password';
      } else {
        //   this._logger.log(error, 'error');
        this.error = UtilFns.getErrorMessage(err);
      }
      this.working = false;
    }
  }
}
